import React, { Component, createRef } from 'react'
import { LinkedListMutator as LL } from '../../../lib/io/BrianCorr/linked-list-mutator'
import AnimateState from '../../../lib/io/BrianCorr/AnimateState'
import './NotificationBar_style.css'

class NotificationBarCP extends Component {
  constructor(props) {
    super(props)
    this.defaultTTL = 3000
    this.inDur = 700
    this.outDur = 300
    let ll = LL.getNewLinkedList()
    this.state = {
      noteTexts: ll
    }
  }

  render() {
    let items = []

    LL.iterate(this.state.noteTexts, (item) => {
      items.push(
        <div ref={item.eleRef} className='horiz-reader-item' key={item.id}>- {item.text}</div>
      )
    })

    return (
      <div className='horiz-reader'>
        {items}
      </div>
    )
  }

  makeAnim (id, ttl, eleRef) {
    let animCtrl = AnimateState.makeAnimationController(ttl)

    animCtrl.timeline.onSetToPost = () => {
      this.setState((state) => {
        LL.remove(state.noteTexts, id)
        return state
      })
    }

    let inTL = AnimateState.makeTimeline()
    inTL.onFrame = (pct) => {
      if (null !== eleRef.current) {
        pct = 1-pct
        pct = pct * pct
        let pctTxt = pct * 100 + '%'
        eleRef.current.style.top = pctTxt
      }
    }

    let outTL = AnimateState.makeTimeline()
    outTL.onFrame = (pct) => {
      if (null !== eleRef.current) {
        pct = 1-pct
        let pctTxt = pct * 100 + '%'
        eleRef.current.style.opacity = pctTxt
      }
    }

    animCtrl.timeline.addChild(inTL, 0, this.inDur)
    animCtrl.timeline.addChild(outTL, ttl-this.outDur, ttl)

    return animCtrl
  }


  notify (noteText, ttl=null) {
    if (null === ttl) {
      ttl = this.defaultTTL
    }
    let id = '' + Math.floor( Math.random() * 10000000000000000 )
    //let expiration = Date.now() + ttl
    let eleRef = createRef()
    let anim = this.makeAnim(id, ttl, eleRef)

    anim.runFromBeginning()

    this.setState((state) => {
      LL.insertAtTail(state.noteTexts, id, {
        id,
        eleRef,
        anim,
        text: noteText,
      })
      return state
    })
  }
  
}

export default NotificationBarCP